import {
    FETCH_VTIALSRANGELIST_REQUEST,
    FETCH_VTIALSRANGELIST_SUCCESS,
    FETCH_VTIALSRANGELIST_FAILURE,
    FETCH_DEVICESLIST_REQUEST,
    FETCH_DEVICESLIST_SUCCESS,
    FETCH_DEVICESLIST_FAILURE,
    FETCH_PATIENTMAPPEDEVICESLIST_REQUEST,
    FETCH_PATIENTMAPPEDEVICESLIST_SUCCESS,
    FETCH_PATIENTMAPPEDEVICESLIST_FAILURE,
    FETCH_TASKSLIST_REQUEST,
    FETCH_TASKSLIST_SUCCESS,
    FETCH_TASKSLIST_FAILURE,
    FETCH_FREQUENCIESLIST_REQUEST,
    FETCH_FREQUENCIESLIST_SUCCESS,
    FETCH_FREQUENCIESLIST_FAILURE,
    FETCH_ALERTSLIST_REQUEST,
    FETCH_ALERTSLIST_SUCCESS,
    FETCH_ALERTSLIST_FAILURE,
    SET_SELECTEDRPM_PATIENT,
    CLEAR_SELECTEDRPM_PATIENT,
    FETCH_REVIEWSLIST_REQUEST,
    FETCH_REVIEWSLIST_SUCCESS,
    FETCH_REVIEWSLIST_FAILURE,
    FETCH_CARETASKSLIST_REQUEST,
    FETCH_CARETASKSLIST_SUCCESS,
    FETCH_CARETASKSLIST_FAILURE,
    FETCH_CAREDAILYTASKSLIST_REQUEST,
    FETCH_CAREDAILYTASKSLIST_SUCCESS,
    FETCH_CAREDAILYTASKSLIST_FAILURE,
    FETCH_USERNOTESTOPATIENT_REQUEST,
    FETCH_USERNOTESTOPATIENT_SUCCESS,
    FETCH_USERNOTESTOPATIENT_FAILURE,
    FETCH_CAREDAILYMEDLIST_REQUEST,
    FETCH_CAREDAILYMEDLIST_SUCCESS,
    FETCH_CAREDAILYMEDLIST_FAILURE,
    FETCH_CAREMEDICATIONSLIST_REQUEST,
    FETCH_CAREMEDICATIONSLIST_SUCCESS,
    FETCH_CAREMEDICATIONSLIST_FAILURE,
    FETCH_ACTIVITYREPORT_REQUEST,
    FETCH_ACTIVITYREPORT_SUCCESS,
    FETCH_ACTIVITYREPORT_FAILURE,
    FETCH_RPMCONFIGVITALSLIST_REQUEST,
    FETCH_RPMCONFIGVITALSLIST_SUCCESS,
    FETCH_RPMCONFIGVITALSLIST_FAILURE,
    FETCH_PATCLINICALSTATUS_REQUEST,
    FETCH_PATCLINICALSTATUS_SUCCESS,
    FETCH_PATCLINICALSTATUS_FAILURE,
    FETCH_PATCALENDERACTIVITY_REQUEST,
    FETCH_PATCALENDERACTIVITY_SUCCESS,
    FETCH_PATCALENDERACTIVITY_FAILURE,
    FETCH_RPMPATIENTFILTERCOUNT_REQUEST,
    FETCH_RPMPATIENTFILTERCOUNT_SUCCESS,
    FETCH_RPMPATIENTFILTERCOUNT_FAILURE,
    FETCH_RPMLOCWISECHRONICS_REQUEST,
    FETCH_RPMLOCWISECHRONICS_SUCCESS,
    FETCH_RPMLOCWISECHRONICS_FAILURE,
    FETCH_RPMAGEWISECHRONICS_REQUEST,
    FETCH_RPMAGEWISECHRONICS_SUCCESS,
    FETCH_RPMAGEWISECHRONICS_FAILURE,
    FETCH_DASHBOARDCOMPLIANCE_REQUEST,
    FETCH_DASHBOARDCOMPLIANCE_SUCCESS,
    FETCH_DASHBOARDCOMPLIANCE_FAILURE
} from "../actions/rpmActions";

const initialState = {
    mappedDevicesList: [],
    devicesList: [],
    tasksList: [],
    frequenciesList: [],
    alertsList: [],
    reviewsList: [],
    careTasksList: [],
    careDailyTasksList: [],
    careDailyMedsList: [],
    careMedicationsList: [],
    userNotesToPatient: [],
    rpmConfigVitalsList: [],
    rpmCalenderActivity: [],
    rpmLocWiseChronicList: [],
    rpmAgeWiseChronicList: [],
    rpmPatientFiltersCount: null,
    rpmDashboardCompliance:null,
    clinicalStatus: null,
    rpmActivityReport: null,
    selectedRpmPatient: null,
    isLoading: false,
    error: null
};

export const rpmReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_VTIALSRANGELIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_VTIALSRANGELIST_SUCCESS:
            return { ...state, vitalRangesList: action.payload, isLoading: false };

        case FETCH_VTIALSRANGELIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_DEVICESLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_DEVICESLIST_SUCCESS:
            return { ...state, devicesList: action.payload, isLoading: false };

        case FETCH_DEVICESLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_PATIENTMAPPEDEVICESLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PATIENTMAPPEDEVICESLIST_SUCCESS:
            return { ...state, mappedDevicesList: action.payload, isLoading: false };

        case FETCH_PATIENTMAPPEDEVICESLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_TASKSLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_TASKSLIST_SUCCESS:
            return { ...state, tasksList: action.payload, isLoading: false };

        case FETCH_TASKSLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_FREQUENCIESLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_FREQUENCIESLIST_SUCCESS:
            return { ...state, frequenciesList: action.payload, isLoading: false };

        case FETCH_FREQUENCIESLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_ALERTSLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_ALERTSLIST_SUCCESS:
            return { ...state, alertsList: action.payload, isLoading: false };

        case FETCH_ALERTSLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_REVIEWSLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_REVIEWSLIST_SUCCESS:
            return { ...state, reviewsList: action.payload, isLoading: false };

        case FETCH_REVIEWSLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_CARETASKSLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_CARETASKSLIST_SUCCESS:
            return { ...state, careTasksList: action.payload, isLoading: false };

        case FETCH_CARETASKSLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_CAREDAILYTASKSLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_CAREDAILYTASKSLIST_SUCCESS:
            return { ...state, careDailyTasksList: action.payload, isLoading: false };

        case FETCH_CAREDAILYTASKSLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_USERNOTESTOPATIENT_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_USERNOTESTOPATIENT_SUCCESS:
            return { ...state, userNotesToPatient: action.payload, isLoading: false };

        case FETCH_USERNOTESTOPATIENT_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_CAREDAILYMEDLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_CAREDAILYMEDLIST_SUCCESS:
            return { ...state, careDailyMedsList: action.payload, isLoading: false };

        case FETCH_CAREDAILYMEDLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_CAREMEDICATIONSLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_CAREMEDICATIONSLIST_SUCCESS:
            return { ...state, careMedicationsList: action.payload, isLoading: false };

        case FETCH_CAREMEDICATIONSLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_ACTIVITYREPORT_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_ACTIVITYREPORT_SUCCESS:
            return { ...state, rpmActivityReport: action.payload, isLoading: false };

        case FETCH_ACTIVITYREPORT_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_RPMCONFIGVITALSLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_RPMCONFIGVITALSLIST_SUCCESS:
            return { ...state, rpmConfigVitalsList: action.payload, isLoading: false };

        case FETCH_RPMCONFIGVITALSLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_PATCLINICALSTATUS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PATCLINICALSTATUS_SUCCESS:
            return { ...state, clinicalStatus: action.payload, isLoading: false };

        case FETCH_PATCLINICALSTATUS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_PATCALENDERACTIVITY_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PATCALENDERACTIVITY_SUCCESS:
            return { ...state, rpmCalenderActivity: action.payload, isLoading: false };

        case FETCH_PATCALENDERACTIVITY_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_RPMPATIENTFILTERCOUNT_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_RPMPATIENTFILTERCOUNT_SUCCESS:
            return { ...state, rpmPatientFiltersCount: action.payload, isLoading: false };

        case FETCH_RPMPATIENTFILTERCOUNT_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_RPMLOCWISECHRONICS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_RPMLOCWISECHRONICS_SUCCESS:
            return { ...state, rpmLocWiseChronicList: action.payload, isLoading: false };

        case FETCH_RPMLOCWISECHRONICS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_RPMAGEWISECHRONICS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_RPMAGEWISECHRONICS_SUCCESS:
            return { ...state, rpmAgeWiseChronicList: action.payload, isLoading: false };

        case FETCH_RPMAGEWISECHRONICS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_DASHBOARDCOMPLIANCE_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_DASHBOARDCOMPLIANCE_SUCCESS:
            return { ...state, rpmDashboardCompliance: action.payload, isLoading: false };

        case FETCH_DASHBOARDCOMPLIANCE_FAILURE:
            return { ...state, error: action.payload, isLoading: false };


        case SET_SELECTEDRPM_PATIENT:
            return { ...state, selectedRpmPatient: action.payload };

        case CLEAR_SELECTEDRPM_PATIENT:
            return { ...state, selectedRpmPatient: action.payload };



        default:
            return state;
    }
};
